<content>
    <form [formGroup]="newEditForm" [ngClass]="{'show-error':showError}">
        <div class="info">{{'global.infoRequired' | translate}}</div>
        <h3>{{'usuarios.auditor.modal.datosUsuario' | translate}}</h3>
        <div class="entry-4-modal">
            <label>{{'usuarios.auditor.modal.entidad' | translate}} *</label>
            <app-filterable-list [itemsList]="entidades" [selectedItem]="newEditForm.get('entidadControl')"
                [placeHolder]="false">
            </app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'usuarios.auditor.modal.nombreUsuario' | translate}} *</label>
            <input id="userName" type="email" autocomplete="off" formControlName="userName">
        </div>
        <div class="entry-4-modal" *ngIf="!auditorId && showPassword">
            <label>{{'usuarios.auditor.modal.password' | translate}} *</label>
            <input type="text" formControlName="password">
        </div>
        <div class="entry-4-modal" *ngIf="!auditorId">
            <label>{{'usuarios.auditor.modal.telefono' | translate}}</label>
            <input type="text" formControlName="phoneNumber">
        </div>
        <div class="entry-4-modal" *ngIf="!auditorId">
            <label>{{'usuarios.auditor.modal.direccion' | translate}}</label>
            <input type="text" formControlName="direccion">
        </div>
        <div class="entry-4-modal">
            <label>{{'usuarios.auditor.modal.nombre' | translate}} *</label>
            <input type="text" formControlName="nombre">
        </div>
        <div class="entry-4-modal">
            <label>{{'usuarios.auditor.modal.apellido' | translate}} *</label>
            <input type="text" formControlName="apellido">
        </div>
        <div class="entry-4-modal" *ngIf="!auditorId">
            <label>{{'usuarios.auditor.modal.idioma' | translate}} *</label>
            <app-filterable-list [itemsList]="idiomas" [selectedItem]="newEditForm.get('idioma')" [placeHolder]="false"
                [disabled]="disabledIdioma">
            </app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'usuarios.auditor.modal.timezone' | translate}} *</label>
            <app-filterable-list [itemsList]="timezones" [selectedItem]="newEditForm.get('msTimeZone')"
                [placeHolder]="false" [disabled]="disabledTimezone">
            </app-filterable-list>
        </div>
        <div class="entry-4-modal alignment-start" *ngIf="this.role === 'Administrador'">
            <input type="checkbox" id="activo" formControlName="activo">
            <label for="activo">{{'usuarios.auditor.modal.activo' | translate}}</label>
        </div>
        <div class="entry-4-modal alignment-start" *ngIf="this.role === 'Administrador'">
            <input type="checkbox" id="useTwoFactor" formControlName="useTwoFactor">
            <label for="useTwoFactor">{{'usuarios.auditor.modal.useTwoFactor' | translate}}</label>
        </div>
        <div class="entry-4-modal alignment-start" *ngIf="this.role === 'Administrador'">
          <input type="checkbox" id="gestionRoyalties" formControlName="gestionRoyalties">
          <label for="gestionRoyalties">{{'usuarios.auditor.modal.gestionRoyalties' | translate}}</label>
        </div>
        <div class="entry-4-modal alignment-start" *ngIf="this.role === 'Administrador'">
          <input type="checkbox" id="mostrarLicencias" formControlName="mostrarLicencias">
          <label for="mostrarLicencias">{{'usuarios.auditor.modal.mostrarLicencias' | translate}}</label>
        </div>
        <div class="entry-4-modal alignment-start" *ngIf="this.role === 'Administrador'">
            <input type="checkbox" id="permisoEscrituraModal" formControlName="permisoEscritura">
            <label for="permisoEscrituraModal">{{'usuarios.auditor.modal.permisoEscritura' | translate}}</label>
        </div>
        <!-- <div class="entry-4-modal">
            <input type="checkbox" id="duplicacionDesignaciones" formControlName="duplicacionDesignaciones">
            <label for="duplicacionDesignaciones">{{'usuarios.auditor.modal.duplicacionDesignaciones' | translate}}</label>
        </div> -->
        <h3>{{'usuarios.auditor.modal.configuracionAlertas' | translate}}</h3>
        <div class="entry-4-modal">
            <label>{{ 'emailSubscription.sendEmailReport' | translate }} *</label>
            <app-filterable-list class="short-list" [itemsList]="alertasEmail"
                [selectedItem]="newEditForm.get('alertasEmail')" [placeHolder]="false">
            </app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{ 'emailSubscription.report' | translate }} {{ 'emailSubscription.sncReimpresiones' | translate }} *</label>
            <app-filterable-list class="short-list" [itemsList]="reimpresionesSnc" [selectedItem]="newEditForm.get('reimpresionesSnc')"
                [placeHolder]="false">
            </app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{ 'emailSubscription.report' | translate }} {{ 'emailSubscription.numReimpresiones' | translate }} *</label>
            <app-filterable-list class="short-list" [itemsList]="reimpresionesNum" [selectedItem]="newEditForm.get('reimpresionesNum')"
                [placeHolder]="false">
            </app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label style="white-space: nowrap;">{{ 'emailSubscription.report' | translate }} {{ 'emailSubscription.excesoDesignaciones' | translate }} *</label>
            <app-filterable-list class="short-list" [itemsList]="excesosDesignaciones" [selectedItem]="newEditForm.get('excesosDesignaciones')"
                [placeHolder]="false">
            </app-filterable-list>
        </div>
        <div class="entry-4-modal alignment-start">
            <input type="checkbox" id="envio-inmediato" formControlName="envioInmediatoAlerta">
            <label for="envio-inmediato">{{ 'emailSubscription.sendImmediately' | translate}}</label>
        </div>
    </form>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{auditorId ? ('global.actualizar' | translate ) : ('global.insertar' | translate
        )}}</button>
</footer>
<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event"></app-toast>
<div class="modal" *ngIf="showModal">
    <div class="modal-content">
        <header>
            <h4>{{'usuarios.modalRegistro.header' | translate}}</h4>
        </header>
        <content>
            <p>{{'usuarios.modalRegistro.content' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="hideModal()">{{ 'global.aceptar' | translate }}</button>
        </footer>
    </div>
</div>
